(function () {
  var VERSION = "2026-07-07";
  var STORAGE_KEY = "korrhaus_b2c_attribution_v1";
  var COOKIE_KEY = "kh_b2c_attr";
  var SYNC_KEY = "korrhaus_b2c_attribution_synced_v1";
  var ATTR_PREFIX = "_kh_attr_";
  var ATTR_MAX = {
    url: 500,
    text: 160,
    id: 240,
  };

  function clamp(value, max) {
    value = value == null ? "" : String(value);
    return value.length > max ? value.slice(0, max) : value;
  }

  function nowIso() {
    return new Date().toISOString();
  }

  function storageGet(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function storageSet(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      // Local storage can be unavailable in strict privacy modes.
    }
  }

  function sessionGet(key) {
    try {
      return window.sessionStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function sessionSet(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (error) {
      // Session storage can be unavailable in strict privacy modes.
    }
  }

  function cookieGet(name) {
    var match = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
    if (!match) return null;
    try {
      return decodeURIComponent(match[1]);
    } catch (error) {
      return null;
    }
  }

  function cookieSet(name, value) {
    var maxAge = 60 * 60 * 24 * 90;
    document.cookie = name + "=" + encodeURIComponent(value) + "; path=/; max-age=" + maxAge + "; SameSite=Lax";
  }

  function readAttribution() {
    var raw = storageGet(STORAGE_KEY) || cookieGet(COOKIE_KEY);
    if (!raw) return {};
    try {
      return JSON.parse(raw) || {};
    } catch (error) {
      return {};
    }
  }

  function writeAttribution(data) {
    var raw = JSON.stringify(data);
    storageSet(STORAGE_KEY, raw);
    cookieSet(COOKIE_KEY, raw);
  }

  function normalizeUrl(value) {
    if (!value) return "";
    try {
      var url = new URL(value, window.location.origin);
      url.hash = "";
      return clamp(url.toString(), ATTR_MAX.url);
    } catch (error) {
      return clamp(value, ATTR_MAX.url);
    }
  }

  function isKorrhausHost(hostname) {
    return /(^|\.)korrhaus\.nl$/i.test(hostname) || /(^|\.)myshopify\.com$/i.test(hostname);
  }

  function externalReferrer() {
    if (!document.referrer) return "";
    try {
      var referrer = new URL(document.referrer);
      if (referrer.hostname === window.location.hostname) return "";
      if (isKorrhausHost(referrer.hostname) && isKorrhausHost(window.location.hostname)) return "";
      return normalizeUrl(referrer.toString());
    } catch (error) {
      return "";
    }
  }

  function matchingSourceFromHost(hostname) {
    var host = hostname.toLowerCase();
    if (host.indexOf("google.") !== -1) return { source: "google", medium: "organic", channel: "google_seo" };
    if (host.indexOf("bing.") !== -1) return { source: "bing", medium: "organic", channel: "bing_seo" };
    if (host.indexOf("yahoo.") !== -1) return { source: "yahoo", medium: "organic", channel: "organic_search" };
    if (host.indexOf("duckduckgo.") !== -1) return { source: "duckduckgo", medium: "organic", channel: "organic_search" };
    if (host.indexOf("instagram.") !== -1 || host === "l.instagram.com") {
      return { source: "instagram", medium: "organic_social", channel: "instagram_organic" };
    }
    if (host.indexOf("facebook.") !== -1 || host === "l.facebook.com") {
      return { source: "facebook", medium: "organic_social", channel: "facebook_organic" };
    }
    if (host.indexOf("pinterest.") !== -1) return { source: "pinterest", medium: "organic_social", channel: "pinterest_organic" };
    if (host.indexOf("tiktok.") !== -1) return { source: "tiktok", medium: "organic_social", channel: "tiktok_organic" };
    if (host.indexOf("youtube.") !== -1 || host.indexOf("youtu.be") !== -1) {
      return { source: "youtube", medium: "organic_social", channel: "youtube_organic" };
    }
    if (host.indexOf("chatgpt.") !== -1 || host.indexOf("perplexity.") !== -1 || host.indexOf("gemini.") !== -1) {
      return { source: host.replace(/^www\./, ""), medium: "referral", channel: "ai_assistant" };
    }
    return { source: host.replace(/^www\./, ""), medium: "referral", channel: "referral" };
  }

  function sourceFromClickId(params) {
    var clickIds = [
      ["gclid", "google", "cpc", "google_paid"],
      ["gbraid", "google", "cpc", "google_paid"],
      ["wbraid", "google", "cpc", "google_paid"],
      ["msclkid", "bing", "cpc", "bing_paid"],
      ["fbclid", "facebook", "paid_social", "facebook_paid_or_social"],
      ["ttclid", "tiktok", "paid_social", "tiktok_paid_or_social"],
      ["li_fat_id", "linkedin", "paid_social", "linkedin_paid_or_social"],
    ];

    for (var i = 0; i < clickIds.length; i += 1) {
      var item = clickIds[i];
      var value = params.get(item[0]);
      if (value) {
        return {
          click_id_key: item[0],
          click_id: clamp(value, ATTR_MAX.id),
          source: item[1],
          medium: item[2],
          channel: item[3],
        };
      }
    }

    return null;
  }

  function channelFor(source, medium, fallbackChannel) {
    var sourceText = String(source || "").toLowerCase();
    var mediumText = String(medium || "").toLowerCase();
    if (fallbackChannel) return fallbackChannel;
    if (sourceText === "direct") return "direct";
    if (sourceText.indexOf("google") !== -1 && /product_sync|sag_organic|organic_shopping|shopping/i.test(mediumText)) {
      return "google_free_listing";
    }
    if (sourceText.indexOf("google") !== -1 && /cpc|paid|ppc/i.test(mediumText)) return "google_paid";
    if (sourceText.indexOf("google") !== -1) return "google_seo";
    if (sourceText.indexOf("instagram") !== -1 || sourceText === "ig") return "instagram_organic";
    if (sourceText.indexOf("facebook") !== -1 || sourceText === "fb") return "facebook_organic";
    if (sourceText.indexOf("tiktok") !== -1) return "tiktok_organic";
    if (sourceText.indexOf("pinterest") !== -1) return "pinterest_organic";
    if (/email|newsletter/i.test(mediumText) || /klaviyo|mailchimp/i.test(sourceText)) return "email";
    if (mediumText === "referral") return "referral";
    if (mediumText === "organic") return "organic_search";
    return sourceText ? "other" : "unknown";
  }

  function detectTraffic() {
    var params = new URLSearchParams(window.location.search);
    var referrer = externalReferrer();
    var click = sourceFromClickId(params);
    var utmSource = params.get("utm_source");
    var utmMedium = params.get("utm_medium");
    var utmCampaign = params.get("utm_campaign");
    var source = utmSource || (click && click.source);
    var medium = utmMedium || (click && click.medium);
    var campaign = utmCampaign || "";
    var channel = "";
    var hasExplicitSignal = Boolean(source || medium || campaign || click);

    if (!hasExplicitSignal && referrer) {
      try {
        var referrerUrl = new URL(referrer);
        var matched = matchingSourceFromHost(referrerUrl.hostname);
        source = matched.source;
        medium = matched.medium;
        channel = matched.channel;
        hasExplicitSignal = true;
      } catch (error) {
        source = "referral";
        medium = "referral";
        channel = "referral";
        hasExplicitSignal = true;
      }
    }

    if (!hasExplicitSignal && !document.referrer) {
      source = "direct";
      medium = "none";
      channel = "direct";
      hasExplicitSignal = true;
    }

    channel = channelFor(source, medium, channel);

    return {
      source: clamp(source || "", ATTR_MAX.text),
      medium: clamp(medium || "", ATTR_MAX.text),
      campaign: clamp(campaign, ATTR_MAX.text),
      content: clamp(params.get("utm_content") || "", ATTR_MAX.text),
      term: clamp(params.get("utm_term") || "", ATTR_MAX.text),
      channel: clamp(channel, ATTR_MAX.text),
      landing: normalizeUrl(window.location.href),
      referrer: referrer,
      click_id_key: click ? click.click_id_key : "",
      click_id: click ? click.click_id : "",
      captured_at: nowIso(),
      has_signal: hasExplicitSignal,
      is_direct: source === "direct",
    };
  }

  function mergeTouch(stored, touch) {
    var next = stored || {};
    if (!touch.has_signal) return next;

    if (!next.first || !next.first.source) {
      next.first = touch;
    }

    next.last = touch;
    if (!touch.is_direct) {
      next.last_non_direct = touch;
    }

    next.version = VERSION;
    next.updated_at = nowIso();
    return next;
  }

  function attrName(name) {
    return ATTR_PREFIX + name;
  }

  function compactUrl(value) {
    if (!value) return "";
    try {
      var url = new URL(value, window.location.origin);
      [
        "fbclid",
        "gclid",
        "gbraid",
        "wbraid",
        "msclkid",
        "ttclid",
        "li_fat_id",
        "utm_id",
      ].forEach(function (param) {
        url.searchParams.delete(param);
      });
      url.hash = "";
      return clamp(url.toString(), ATTR_MAX.url);
    } catch (error) {
      return clamp(value, ATTR_MAX.url);
    }
  }

  function preferredTouch(data) {
    return data.last_non_direct || data.last || data.first || null;
  }

  function summaryForTouch(touch) {
    var parts = [];
    if (touch.channel) parts.push(touch.channel);
    if (touch.source) parts.push(touch.source);
    if (touch.medium) parts.push(touch.medium);
    if (touch.campaign) parts.push(touch.campaign);
    if (touch.content) parts.push(touch.content);
    return clamp(parts.join(" / "), ATTR_MAX.text);
  }

  function cartAttributes(data) {
    var attributes = {};
    var touch = preferredTouch(data);

    if (touch) {
      attributes[attrName("summary")] = summaryForTouch(touch);
      attributes[attrName("source")] = touch.source || "";
      attributes[attrName("medium")] = touch.medium || "";
      attributes[attrName("campaign")] = touch.campaign || "";
      attributes[attrName("content")] = touch.content || "";
      attributes[attrName("channel")] = touch.channel || "";
      attributes[attrName("landing")] = compactUrl(touch.landing);
    }

    Object.keys(attributes).forEach(function (key) {
      if (attributes[key] === "") delete attributes[key];
    });

    return attributes;
  }

  function cartUpdateUrl() {
    if (window.routes && window.routes.cart_update_url) return window.routes.cart_update_url;
    return "/cart/update.js";
  }

  function syncCartAttributes(reason) {
    var data = readAttribution();
    if (!data.first || !data.first.source) return;

    var attributes = cartAttributes(data);
    var fingerprint = JSON.stringify(attributes);
    if (sessionGet(SYNC_KEY) === fingerprint && reason !== "checkout") return;

    fetch(cartUpdateUrl(), {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ attributes: attributes }),
      credentials: "same-origin",
      keepalive: reason === "checkout" || reason === "pagehide",
    })
      .then(function () {
        sessionSet(SYNC_KEY, fingerprint);
      })
      .catch(function () {
        // Attribution storage remains local; a later page view can retry the cart sync.
      });
  }

  function initialize() {
    var current = readAttribution();
    var touch = detectTraffic();
    var next = mergeTouch(current, touch);
    writeAttribution(next);
    window.KorrhausAttribution = {
      get: readAttribution,
      sync: function () {
        return syncCartAttributes("manual");
      },
    };

    window.setTimeout(function () {
      syncCartAttributes("pageview");
    }, 800);
  }

  document.addEventListener(
    "submit",
    function (event) {
      var form = event.target;
      if (!form || !form.action) return;
      if (form.action.indexOf("/cart") !== -1 || form.action.indexOf("/checkout") !== -1) {
        syncCartAttributes("checkout");
      }
    },
    true
  );

  document.addEventListener(
    "click",
    function (event) {
      var target = event.target && event.target.closest ? event.target.closest("a,button,input") : null;
      if (!target) return;
      var href = target.href || "";
      var name = target.name || "";
      var type = target.type || "";
      if (href.indexOf("/checkout") !== -1 || name === "checkout" || type === "submit") {
        syncCartAttributes("checkout");
      }
    },
    true
  );

  window.addEventListener("pagehide", function () {
    syncCartAttributes("pagehide");
  });

  initialize();
})();
